export default 'Decrease number';